import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class Beruf {
  constructor({
    id,
    markierung,
    name,
    abkuerzung,
    istAusbildung,
  }: {
    id: string;
    markierung: Markierung;
    name: string;
    abkuerzung: string;
    istAusbildung: boolean;
  }) {
    this.id = id;
    this.markierung = markierung;
    this.name = name;
    this.abkuerzung = abkuerzung;
    this.istAusbildung = istAusbildung;
  }

  id: string;
  markierung: Markierung;
  name: string;
  abkuerzung: string;
  istAusbildung: boolean;

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }
}
